<template>
  <div class="layout-menu-group-dialog">
    <div class="kye-dialog-body dialog-body">
      <Sider ref="sider"
        @add="handleAddGroup"
        v-loading="siderLoading"
        @sortChange="onSiderSortChange"
        @delete="handleDeleteGroup"
        @change="onGroupChange" />
      <TagList
        ref="tagList"
        :tags="tagList"
        :activeItem="activeItem"
        @move="handleMove"
        v-loading="tagLoading"
        @sortChange="onTagSortChange"
        @delete="handleDelete"
        @add="handleAdd" />
    </div>
    <kye-dialog v-bind="dialogOption"
                :view.sync="dialogOption.view"
                style="min-height: none"
                class="layout-menu-group-child-dialog"
                :visible.sync="dialogOption.show">
      <component :is="dialogOption.view"
                :dialogData="dialogData"
                :menuGroup="curMenuGroup"
                @updateGroup="handleUpdateGroup"
                @update="updateTagList"
                @close="closeDialog"></component>
    </kye-dialog>
  </div>
</template>

<script>
  // 弹窗混入
  import dialogMixins from '../../dialog'
  // 左侧内容
  import Sider from './sider'
  // 分组标签
  import TagList from './tag-list'
  import AddMenuDialog from '../add-menu-dialog'
  // 移动到分组
  import MoveGroupDialog from './move-group-dialog'
  // 新增分组名称弹窗
  import AddGroupDialog from './add-group-dialog'
  export default {
    components: { Sider, TagList, AddMenuDialog, MoveGroupDialog, AddGroupDialog },
    mixins: [dialogMixins],
    data() {
      return {
        activeItem: null,
        tagList: [], // 右侧标签列表
        groupList: [], // 左侧分组列表
        dialogData: null,
        siderLoading: false,
        tagLoading: false
      }
    },
    computed: {
      // 转化分组数据
      curMenuGroup () {
        if (!this.activeItem) return null
        return {
          moduleGroupId: this.activeItem.id,
          moduleGroupName: this.activeItem.groupName
        }
      },
      menus () {
        return this.$store.getters.menus
      }
    },
    mounted () {
      this.init()
    },
    methods: {
      async init () {
        await this.initGroupList()
        this.initTagList()
      },
      onGroupChange(item) {
        this.$refs.tagList && this.$refs.tagList.handleBatchCancel()
        this.activeItem = item
        this.initTagList()
      },
      async initTagList(initFlag = true) {
        try {
          this.tagLoading = true
          const res = await this.$http('system.homeIndex.list', {moduleGroupId: this.activeItem.id, moduleType: 10})
          const menus = this.menus
          this.tagList = res.filter(item => menus[item.url])
          initFlag && this.$refs.tagList && this.$refs.tagList.initCheckData()
        } catch (e) {
          this.tagList = []
        } finally {
          this.tagLoading = false
        }
      },
      async initGroupList (data) {
        try {
          this.siderLoading = true
          const res = await this.$http('system.homeModuleGroup.list', {userId: this.$store.state.user.id})
          this.groupList = res
          if (data) {
            this.activeItem = this.activeItem.id === data.id ? {...this.activeItem, groupName: data.groupName} : this.groupList[0]
          } else {
            this.activeItem = this.groupList[0]
          }
          this.$refs.sider.setList(res)
          this.$refs.sider.setModuleGroupId(this.activeItem.id)
        } catch (error) {
          this.groupList = []
        } finally {
          this.siderLoading = false
        }
      },
      // 移动到
      handleMove (tag) {
        this.dialogData = {
          tag,
          groupList: this.groupList
        }
        this.showDialog('MoveGroupDialog', '移动到分组', '400px')
      },
      // 删除标签
      async handleDelete (tag) {
        await this.$confirm('是否删除模块？')
        const params = tag.map(item => item.id)
        await this.$http('system.homeIndex.deleteByIds', params)
        this.$message.success('删除成功！')
        this.initTagList()
        this.$emit('update')
      },
      // 添加常用
      handleAdd () {
        this.showDialog('AddMenuDialog', '常用模块管理', '830px')
      },
      // 新增分组
      handleAddGroup (group) {
        this.dialogData = group
        this.showDialog('AddGroupDialog', '设置分组名称', '300px')
        // this.initGroupList()
        // this.$emit('update')
      },
      // 删除分组
      async handleDeleteGroup (group) {
        await this.$confirm('是否删除分组?')
        await this.$http('system.homeModuleGroup.deleteById', {id: group.id})
        if (this.activeItem.id === group.id) {
          this.activeItem = null
          this.tagList = []
          this.$refs.tagList && this.$refs.tagList.handleBatchCancel()
        }
        this.$message.success('删除成功！')
        this.init()
        this.$emit('update')
      },
      updateTagList () {
        this.initTagList()
        this.$emit('update')
      },
      async handleUpdateGroup(updateGroup) {
        if (updateGroup) {
          this.initGroupList(updateGroup)
        } else {
          this.init()
        }
        this.$emit('update')
        this.$refs.tagList && this.$refs.tagList.handleBatchCancel()
      },
      async onSiderSortChange (list) {
        try {
          this.siderLoading = true
          const params = list.map((item, index) => ({id: item.id, displaySequence: index + 1})).filter(item => +item.id !== 1)
          await this.$http('system.homeModuleGroup.setModuleSort', params)
          this.$emit('update', true)
          this.siderLoading = false
        } catch (error) {
          this.siderLoading = false
        }
      },
      async onTagSortChange () {
        try {
          this.tagLoading = true
          const params = this.tagList.map((item, index) => ({id: item.id, displaySequence: index + 1}))
          await this.$http('system.homeIndex.setHomeIndexSort', params)
          this.initTagList(false)
          this.$emit('update')
          this.tagLoading = false
        } catch (error) {
          this.tagLoading = false
        }
      }
    }
  }
</script>

<style lang="less" scoped>
.layout-menu-group-dialog {
  .dialog-body {
    display: flex;
  }
  /deep/ .layout-menu-group-child-dialog {
    .kye-dialog-dynamic {
      min-height: auto !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/common-menu-card/menu-group-dialog/index.vue